import { render, staticRenderFns } from "./ProductTag.vue?vue&type=template&id=258c2d3f&"
import script from "./ProductTag.vue?vue&type=script&lang=js&"
export * from "./ProductTag.vue?vue&type=script&lang=js&"
import style0 from "./ProductTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports